import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import HeaderCondoAdministrator from '@/components/condo-administrator/header.vue';
import moment from 'moment-business-days';
import { saveFiles2 } from '@/services/s3-upload-service';
import { createRandomPasswordContractor } from '@/services';
import { createSolicitation } from '@/services/api/quotation';
import { getAdministradorData } from '@/services/api/administrator';
import { sendNotificationRequestQuotation } from '@/services/api/quotation';
import { getQuotationCategories } from '@/utils/quotation-categories-service';
import { mapActions } from 'vuex';
import { TERMS_OF_USE } from '@/utils/constants';
import { MAIN_SERVICES } from '@/utils/constants';
import { getServicesContractors } from '@/services/api/quotation';
import { setCookie } from '@/services/cookie-service';
import { KEYS } from '@/utils/constants';

export default {
    name: 'LandingPageCondo',
    props: {
        isMobile: [Object, Boolean]
    },
    components: { HeaderCondoAdministrator, flatPickr },
    data: () => ({
        valid: false,
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        },
        emailRules: {
            name: 'Email',
            type: 'email',
            required: true,
            valid: true
        },
        form: {
            street: '',
            attachments: [],
            cep: '',
            city: '',
            email: '',
            name: '',
            dateLimit: undefined,
            neighborhood: '',
            unit: '',
            observations: '',
            phone: '',
            state: '',
            category: [],
            termsOfAgreement: true,
            tradingName: '',
            meetingInfo: '',
            meetingName: '',
            meetingPhone: ''
        },
        pageData: {
            name: '',
            subtitle: '',
            logo: '',
            banner: ''
        },
        fileHasValidSize: true,
        hasError: false,
        showFileSpinner: false,
        showSpinner: false,
        select2Options: {
            deselectLabel: 'Remover',
            selectedLabel: 'Selecionado',
            selectLabel: 'Selecionar'
        },
        tippyOptions: {
            arrow: true,
            arrowType: 'sharp',
            placement: 'top'
        },
        flatPickrOptions: {
            monthSelectorType: 'dropdown',
            // altInput: true,
            altFormat: 'd/m/Y',
            dateFormat: 'd/m/Y',
            disable: [
                function(date) {
                    return date.getDay() === 0 || date.getDay() === 6;
                }
            ],
            locale: Portuguese,
            minDate: moment(new Date(), 'DD-MM-YYYY')
                .startOf('day')
                .businessAdd(3)._d,
            mode: 'single'
        },
        disableCreateQuotationButton: false,
        hasCEPError: false,
        quotationObservations: '',
        windowLocationOrigin: window.location.origin,
        backendErrorMessages: '',
        isTagSelected: false,
        categories: [],
        partner: '',
        showAlert: false,
        message: '',
        loading: false,
        completedForm: false,
        TERMS_OF_USE: TERMS_OF_USE,
        tagList: [
            {
                order: 'Serviços mais buscados',
                tagServices: MAIN_SERVICES
            },
            {
                order: 'Outros serviços',
                tagServices: []
            }
        ],
    }),
    async created() {
        this.tagList[1].tagServices = await getServicesContractors();
        try {
            this.partner = this.$route.params.partner;
            this.categories = getQuotationCategories();
            const data = await getAdministradorData(this.partner);
            this.pageData = data;
        } catch (error) {
            console.error(error);
        }
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        removeAttachment(index) {
            this.form.attachments.splice(index, 1);
        },
        cepRequest(data) {
            this.form.street = data.street;
            this.form.city = data.city;
            this.form.state = data.state;
            this.form.neighborhood = data.neighborhood;
        },
        async createRandomPasswordContractor() {
            this.loading = true;
            try {
                const data = {
                    postal_code: this.form.cep,
                    city: this.form.city,
                    email: this.form.email,
                    neighborhood: this.form.neighborhood,
                    phone: this.form.phone,
                    name: this.form.name,
                    state: this.form.state,
                    street: this.form.street,
                    trading_name: this.form.tradingName
                };
                const { token } = await createRandomPasswordContractor(data);
                setCookie(KEYS.CREDENTIALS_TOKEN, token, 1);
                await this.createSolicitation();
            } catch (error) {
                this.showNotification({ text: 'Aconteceu um erro inesperado', type: 'error' });
                console.error(error);
                this.loading = false;
            }
        },
        async createSolicitation() {
            this.loading = true;
            try {
                let attachments = undefined;
                if (this.form.attachments.length > 0) {
                    try {
                        const uploadFilesToS3BucketResponse = await saveFiles2(this.form.attachments);
                        attachments = uploadFilesToS3BucketResponse;
                    } catch (error) {
                        console.error(error);
                        attachments = undefined;
                    }
                }

                const data = {
                    cep: this.form.cep,
                    city: this.form.city,
                    email: this.form.email,
                    ending_date: moment(this.form.dateLimit, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    attachments: attachments,
                    meeting_info: this.form.meetingInfo,
                    district: this.form.neighborhood,
                    observations: this.form.observations,
                    phone: this.form.phone,
                    responsible: this.form.name,
                    slug: this.partner,
                    state: this.form.state,
                    street: this.form.street,
                    technical_visit_responsible: this.form.meetingName,
                    technical_visit_responsible_phone: this.form.meetingPhone,
                    title: this.form.category.name,
                    trading_name: this.form.tradingName,
                    unit: this.form.unit
                };
                await createSolicitation(data);
                this.completedForm = true;
                this.loading = false;
                this.showNotification({
                    text: 'Solicitação de cotação recebida com sucesso.',
                    type: 'success'
                });
                this.form.cep = ''
                this.form.city = ''
                this.form.email = ''
                this.form.dateLimit = ''
                this.form.attachments = []
                this.form.meetingInfo = ''
                this.form.neighborhood = ''
                this.form.observations = ''
                this.form.phone = ''
                this.form.name = ''
                this.partner = ''
                this.form.state = ''
                this.form.street = ''
                this.form.meetingName = ''
                this.form.meetingPhone = ''
                this.form.category.name = ''
                this.form.tradingName = ''
                this.form.unit = ''
            } catch (error) {
                console.error(error);
                this.showNotification({ text: 'Aconteceu um erro inesperado', type: 'error' });
                this.loading = false;
            }
        },
        convertFileToBase64(event) {
            const reader = new FileReader();
            const file = event.target.files[0];

            const self = this;
            reader.onload = function(e) {
                self.fileHasValidSize = self._validateAttachmentSize(file);
                self.showFileSpinner = false;
                if (self.fileHasValidSize) {
                    self.form.attachments.push({
                        file: e.target.result,
                        file_name: file.name
                    });
                }
            };
            reader.onerror = function(error) {
                console.error(error);
                self.showFileSpinner = false;
            };

            if (file) {
                this.showFileSpinner = true;
                reader.readAsDataURL(file);
            }
        },
        _validateAttachmentSize: function(file) {
            const maximumFileSizeInMegabytes = 25;
            const fileSizeInMegabytes = file.size / 1024 / 1024;
            return fileSizeInMegabytes <= maximumFileSizeInMegabytes;
        },
        async validateForm() {
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            if (this.formValid) {
                if (!this.form.termsOfAgreement) {
                    window.scrollTo(500, 500);
                    this.message = 'Por favor, aceite os termos de uso';
                    return (this.showAlert = true);
                } else {
                    this.loading = true;
                    await this.createRandomPasswordContractor();
                }
            } else {
                this.textRules.valid = false;
                window.scrollTo(500, 500);
                this.message = 'Preencha os campos obrigatórios';
                return (this.showAlert = true);
            }
        },
        addTag(searchQuery) {
            this._selectTag(searchQuery);
            this.isTagSelected = true;
            this.searchQuery = '';
        },
        _selectTag(value) {
            const tag = {
                id: Math.floor(Math.random() * 10000000) + 1000,
                isTag: true,
                name: value
            };

            this.form.category = tag;
        },
        inputSelect(value) {
            this.searchQuery = value;
        },
        selectItem() {
            this.isTagSelected = false;
            this.searchQuery = '';
        },
        closeSelect() {
            if (this.searchQuery) {
                this._selectTag(this.searchQuery);
                this.isTagSelected = false;
                this.searchQuery = '';
            }
        },
        sendNotificationRequestQuotationData() {
            if (!this.completedForm && this.form.name.length && this.form.phone.length) {
                this.completedForm = true;
                sendNotificationRequestQuotation(this.form);
            }
        },
        goToTermsOfUse() {
            const routeData = this.$router.resolve({name: 'pageTermsOfUse'});
            window.open(routeData.href, '_blank');
        }
    },
    destroyed() {
        this.sendNotificationRequestQuotationData();
    },
    computed: {
        disableSubmitButton() {
            return this.emailRules.valid && this.textRules.valid ? true : false;
        },
        formValid() {
            return (
                this.disableSubmitButton &&
                this.form.observations.trim() != '' &&
                this.form.dateLimit != undefined &&
                this.form.dateLimit.trim() != '' &&
                this.form.tradingName.trim() != '' &&
                this.form.cep.trim() != '' &&
                this.form.name.trim() != '' &&
                this.form.email.trim() != '' &&
                this.form.category.name != ''
            );
        }
    }
};
